/**
 * 单据创建工具类
 * 用于创建完整的单据记录，包括单据主体、历史记录和行信息
 */

class TicketCreator {
  /**
   * 创建单据主体信息
   * @param {Object} rowData - 表单数据
   * @returns {Object} 处理后的单据主体对象
   */
  static createTicket(rowData) {
    return {
      id: rowData.id ? rowData.id : null,
      name: rowData.name ? rowData.name : null,
      ticketType: rowData.ticketType ? rowData.ticketType : null,
      personResponsible: rowData.personResponsible ? rowData.personResponsible : null,
      submitter: rowData.submitter ? rowData.submitter : null,
      reviewer: rowData.reviewer ? rowData.reviewer : null,
      department: rowData.department ? rowData.department : null,
      departmentId: rowData.departmentId ? rowData.departmentId : null,
      collectionsTime: rowData.collectionsTime ? rowData.collectionsTime : null,
      billType: rowData.billType ? rowData.billType : null,
      billTypeId: rowData.billTypeId ? rowData.billTypeId : null,
      correspondents: rowData.correspondents ? rowData.correspondents : null,
      correspondentsId: rowData.correspondentsId ? rowData.correspondentsId : null,
      warehouse: rowData.warehouse ? rowData.warehouse : null,
      warehouseId: rowData.warehouseId ? rowData.warehouseId : null,
      summary: rowData.summary ? rowData.summary : null,
      barcodes: rowData.barcodes ? rowData.barcodes : null,
      scansNumber: rowData.scansNumber ? rowData.scansNumber : null,
      remark: rowData.remark ? rowData.remark : null,
      saleType: rowData.saleType ? rowData.saleType : null,
      saleTypeId: rowData.saleTypeId ? rowData.saleTypeId : null,
      paymentAccount: rowData.paymentAccount ? rowData.paymentAccount : null,
      paymentAccountId: rowData.paymentAccountId ? rowData.paymentAccountId : null,
      payment: rowData.payment ? rowData.payment : null,
      discount: rowData.discount ? rowData.discount : null,
      preferential: rowData.preferential ? rowData.preferential : null,
      prepaidAmount: rowData.prepaidAmount ? rowData.prepaidAmount : null,
      createDate: rowData.createDate ? rowData.createDate : null,
      createUser: rowData.createUser ? rowData.createUser : null,
      updateDate: rowData.updateDate ? rowData.updateDate : null,
      updateUser: rowData.updateUser ? rowData.updateUser : null,
      status: rowData.status ? rowData.status : null
    };
  }

  /**
   * 创建单据历史记录
   * @param {Object} rowData - 表单数据
   * @returns {Object} 处理后的单据历史对象
   */
  static createTicketHis(rowData) {
    return {
      id: rowData.id ? rowData.id : null,
      tickedId: rowData.tickedId ? rowData.tickedId : null,
      processId: rowData.processId ? rowData.processId : null,
      processIndex: rowData.processIndex ? rowData.processIndex : null,
      name: rowData.name ? rowData.name : null,
      ticketType: rowData.ticketType ? rowData.ticketType : null,
      personResponsible: rowData.personResponsible ? rowData.personResponsible : null,
      submitter: rowData.submitter ? rowData.submitter : null,
      reviewer: rowData.reviewer ? rowData.reviewer : null,
      department: rowData.department ? rowData.department : null,
      departmentId: rowData.departmentId ? rowData.departmentId : null,
      collectionsTime: rowData.collectionsTime ? rowData.collectionsTime : null,
      billType: rowData.billType ? rowData.billType : null,
      billTypeId: rowData.billTypeId ? rowData.billTypeId : null,
      correspondents: rowData.correspondents ? rowData.correspondents : null,
      correspondentsId: rowData.correspondentsId ? rowData.correspondentsId : null,
      warehouse: rowData.warehouse ? rowData.warehouse : null,
      warehouseId: rowData.warehouseId ? rowData.warehouseId : null,
      summary: rowData.summary ? rowData.summary : null,
      barcodes: rowData.barcodes ? rowData.barcodes : null,
      scansNumber: rowData.scansNumber ? rowData.scansNumber : null,
      remark: rowData.remark ? rowData.remark : null,
      saleType: rowData.saleType ? rowData.saleType : null,
      saleTypeId: rowData.saleTypeId ? rowData.saleTypeId : null,
      paymentAccount: rowData.paymentAccount ? rowData.paymentAccount : null,
      paymentAccountId: rowData.paymentAccountId ? rowData.paymentAccountId : null,
      payment: rowData.payment ? rowData.payment : null,
      discount: rowData.discount ? rowData.discount : null,
      preferential: rowData.preferential ? rowData.preferential : null,
      prepaidAmount: rowData.prepaidAmount ? rowData.prepaidAmount : null,
      createDate: rowData.createDate ? rowData.createDate : null,
      createUser: rowData.createUser ? rowData.createUser : null,
      updateDate: rowData.updateDate ? rowData.updateDate : null,
      updateUser: rowData.updateUser ? rowData.updateUser : null,
      status: rowData.status ? rowData.status : null,
      conmited: rowData.conmited ? rowData.conmited : null
    };
  }

  /**
   * 创建单据行信息
   * @param {Object} rowData - 行数据
   * @returns {Object} 处理后的单据行对象
   */
  static createTicketLine(rowData) {
    // 这里根据实际的单据行结构进行调整
    return {
      ...rowData
    };
  }

  /**
   * 创建完整的单据记录（包括主体、历史记录和行信息）
   * @param {Object} ticketData - 单据主体数据
   * @param {Array} ticketLines - 单据行数据数组
   * @param {Object} historyData - 历史记录相关数据
   * @returns {Object} 完整的单据对象
   */
  static createCompleteTicket(ticketData, ticketLines = [], historyData = {}) {
    const ticket = this.createTicket(ticketData);
    const ticketHis = this.createTicketHis({ ...ticketData, ...historyData });
    
    return {
      ticket: ticket,
      ticketHistory: ticketHis,
      ticketLines: ticketLines.map(line => this.createTicketLine(line))
    };
  }
}

export default TicketCreator;